import { previewBuilder } from '@gem/modules/file-upload';
import { t } from '@gem/modules/i18n';
import { getFixedSizeBlurredImage } from '@gem/modules/image-resizer';

import { PayloadType } from 'APP/model/message/messageModel.types';

import { FilePayload } from '../FilePayload/FilePayload';

export class VideoPayload extends FilePayload {
  graphicSize;
  _previewUrl;
  duration;

  static MIN_FORWARD_VIDEO_MESSAGE_WIDTH = 200;

  constructor(data) {
    super(data);

    this.payloadType = PayloadType.Video;
    this.graphicSize = data.graphicSize || {};
    this.localPreview = data.localPreview;
    this._previewUrl = data.previewUrl || data.localPreview;
    //TODO: couldn't find the duration property -> projects/b2b-core/src/restApi/types/model/videoResponseData.ts
    this.duration = data.duration;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      previewUrl: this._previewUrl,
      duration: this.duration,
      graphicSize: this.graphicSize,
      localPreview: this.localPreview,
    };
  }

  get previewSize() {
    const { width, height } = this.graphicSize;

    if (!width || !height) {
      return { width, height };
    }

    return FilePayload.calculatePreviewSize(
      width,
      height,
      FilePayload.PREVIEW_MAX_WIDTH,
      FilePayload.PREVIEW_MAX_HEIGHT
    );
  }

  get placeholderUrl() {
    return (
      this.localPreview ||
      getFixedSizeBlurredImage(
        this.previewUrl,
        {
          width: FilePayload.PREVIEW_MAX_WIDTH,
          height: 0,
        },
        this.graphicSize
      )
    );
  }

  get previewUrl() {
    return this.localPreview || this._previewUrl;
  }

  get hasPlaceholder() {
    const { width } = this.previewSize;

    return (
      (width < FilePayload.MIN_QUOTE_WIDTH &&
        (this.message.repliedMessage || this.message.quote)) ||
      (width < VideoPayload.MIN_FORWARD_VIDEO_MESSAGE_WIDTH && this.message.forward)
    );
  }

  get typeDescription() {
    return t('message_desctription_video_file');
  }

  async upload() {
    await super.upload();
    if (this.isLoaded) {
      this._previewUrl = await previewBuilder.getFilePreviewUrl(
        this.userFile,
        this.fileName,
        this.localPreview
      );
    }
  }
}
